import React from 'react';
import QuillEditor from '../../../Components/Editors/QuillEditor'
import { emailImageUpload } from '../../../firebase/storage/uploadFiles'


const ControlledEditor = ({setHtmlCallback, htmlText}) => {

  const onEditorStateChange = (editorState) => {
    return setHtmlCallback(editorState)
  }
  const handleImageUpload = async (file) => {
    const data = await emailImageUpload(file)
    return data
  }

  return (
    <div style={{marginTop: '1rem', minHeight: '500px', backgroundColor: 'whitesmoke'}} >
      <QuillEditor
        imageUpload={handleImageUpload}
        handleChangeCallback={onEditorStateChange}
        editorState={htmlText}
        placeholder='Die Schriftgröße 12px ist die Standardgröße in den meisten E-Mail Clients wie Outlook, es wird hier in der App nur etwas kleiner dargestellt.'
      />
    </div>
  )

}
export default ControlledEditor